import styled from 'styled-components';

export default styled.div`
  ${p => p.theme.type.textSmall}
  margin-top: ${p => p.theme.spacing.xSmall};
  color: ${p => p.theme.colors.redBase};
  font-size: 12px;
  line-height: 16px;
`;
